import React from 'react';
import TickerQuickButtons from './TickerQuickButtons';
import TickerInput from './TickerInput';
import TickerFeed from './TickerFeed';

export default function TickerTab({
    gameId, game, events, lineup, availablePlayers, meta, displayMinute,
    onCreated, onDelete, onUpdate, onMetaUpdate,
}) {
    const publishedCount = events.filter(e => e.published !== false).length;

    return (
        <>
            {/* Composer + Quick actions — fixed at top, no scroll needed */}
            <div className="ticker-dock ticker-dock--top">
                <TickerQuickButtons
                    gameId={gameId}
                    game={game}
                    lineup={lineup}
                    availablePlayers={availablePlayers}
                    meta={meta}
                    displayMinute={displayMinute}
                    onCreated={onCreated}
                    onMetaUpdate={onMetaUpdate}
                    gameFinished={meta?.status === 'finished'}
                />
                <TickerInput
                    gameId={gameId}
                    currentMinute={displayMinute}
                    half={meta?.currentHalf || 1}
                    game={game}
                    availablePlayers={availablePlayers}
                    onCreated={onCreated}
                    gameFinished={meta?.status === 'finished'}
                />
            </div>

            {/* Feed scrolls below — tickerer stays at input */}
            <div className="ticker-feed-scroll">
                <div className="ticker-feed-header">
                    <div>
                        <h2 className="text-sm font-bold text-slate-200">Live-Feed</h2>
                        <p className="text-xs text-slate-500">{publishedCount} Meldungen · neueste oben</p>
                    </div>
                </div>
                <TickerFeed events={events} onDelete={onDelete} onUpdate={onUpdate} gameFinished={meta?.status === 'finished'} />
            </div>
        </>
    );
}
